(function () {
  "use strict";

  angular.module("tikonApp").controller("BlogsCategories", BlogsCategories);

  BlogsCategories.$inject = ["$timeout", "$state", "$rootScope"];

  function BlogsCategories($timeout, $state, $rootScope) {
    function initBlogsCategories() {
      var blogsCategoriesElement = document.getElementById("blogs-categories");
      blogsCategoriesElement.addEventListener("prevPageBtn", function (e) {
        if ($rootScope.fromState.name)
          $state.go($rootScope.fromState.name, $rootScope.fromStateParams);
        else $state.go("supplierPanel-v2.setting");
        // closeModal()
      });
      blogsCategoriesElement.addEventListener("toBlogs", function (e) {
        $state.go("supplierPanel-v2.companyBlogs");
        // closeModal()
      });
    }
    $timeout(initBlogsCategories, 50);
  }
})();
